import utils from '@/utils';
import ProductSchema from '@/models/seo/ProductSchema';
import { Product, Hotel } from 'schema-dts';

/**
 * @type { Product & Hotel }
 * @class
 * @extends ProductSchema
 */
export default class HotelProductSchema extends ProductSchema {
    /**
     * @constructor
     * @param {Object} productDetails
     * @param {Object} hotelDetails
     */
    constructor(productDetails = {}, hotelDetails = {}) {
        const productSchema = super(productDetails);

        const { getSafe } = utils;

        const facilityTags = Array.from(
            // convert to array
            new Set( // remove duplicates
                (productDetails.facilityTags || [])
                    .map(ft => {
                        // Extract text from entry and capitalize it to proper remove duplicates
                        return (ft.entries || []).map(e => (e.text || '').replace(/(^|\s)\S/g, l => l.toUpperCase()));
                    })
                    .flat()
            )
        );

        this['@type'] = ['Product', 'Hotel'];
        this.name = productDetails.hotel;
        this.priceRange = `ab ${productSchema.offers.lowPrice} EUR`;
        this.starRating = {
            '@type': 'Rating',
            ratingValue: getSafe(hotelDetails, 'hotelClassification.classificationValue')
        };
        this.description = productDetails.hotelDescription;
        this.address = {
            '@type': 'PostalAddress',
            streetAddress: hotelDetails.street,
            addressLocality: hotelDetails.city,
            postalCode: hotelDetails.zipcode,
            addressCountry: hotelDetails.country
        };
        this.amenityFeature = facilityTags.map(text => {
            return {
                '@type': 'LocationFeatureSpecification',
                name: text,
                value: true
            };
        });
    }
}
